import { apiHost } from '../helper/apiHost';

/** Public media folders served by the API */
export const MEDIA = {
  website: 'website',
  headers: 'headers',
  covers: 'covers',
  signatures: 'signatures',
  images: 'images',
};

/**
 * Build absolute URL for an uploaded file.
 * @param {'website'|'headers'|'covers'|'signatures'|'images'} kind
 * @param {string} filename
 */
export function mediaUrl(kind, filename) {
  if (!filename) return null;
  const safe = String(filename).replace(/^\/+/, '');
  return `${apiHost}/${kind}/${safe}`;
}

export function headerImageUrl(filename) {
  return mediaUrl(MEDIA.headers, filename);
}

export function coverImageUrl(filename) {
  return mediaUrl(MEDIA.covers, filename);
}

export function signatureImageUrl(filename) {
  return mediaUrl(MEDIA.signatures, filename);
}

export function websiteLogoUrl(filename) {
  return mediaUrl(MEDIA.website, filename);
}

export function websiteFaviconUrl(filename) {
  return mediaUrl(MEDIA.website, filename);
}

/** onError handler: if new folder 404, try legacy /images/ */
export function withLegacyImageFallback(event, filename) {
  const img = event?.currentTarget || event?.target;
  if (!img || !filename || img.dataset.legacyFallback === '1') return;
  img.dataset.legacyFallback = '1';
  img.src = mediaUrl(MEDIA.images, filename);
}
